var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmplitude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#377FC1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logosandtypes_com"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h150v150H0V0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "dermira"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "delifrance"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "fundacion_comillas"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "replay_app"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "alitalia"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "arfadia"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "actively_learn"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Alemite"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Amplitude"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.9,7.3c-36.5,0-66,29.6-66,66s29.6,66,66,66s66-29.6,66-66S111.3,7.3,74.9,7.3z M120.3,74.5 c-0.5,0-0.9,0.1-1.4,0.1c-10,0-20,0.1-30,0.1c-0.3,0-0.6,0-1,0c0.1,0,0.1,0.7,0.2,1c1.3,5.3,2.6,10.6,4,15.8c0.9,3.3,2,6.4,3.4,9.5 c0.5,1.1,1.2,2.1,1.9,3.2c0.2,0.4,0.6,0.7,0.8,1c1.5,1.6,3.5,1.4,4.9,0.5c0.8-0.5,1.4-1.2,1.9-1.9c1-1.4,1.8-3,2.4-4.6 c1.6-4.3,3.2-8.6,4.8-12.9c0.5-1.3,0.9-2.6,1.4-3.9c0.3-0.9,0.7-1.1,1.3-1c0.6,0.2,0.7,0.6,0.5,1.5c-1,3.9-1.9,7.8-3,11.6 c-1,3.7-2.1,7.3-3.8,10.8c-1.1,2.2-2.3,4.3-4.1,6c-1,0.9-2,1.7-3.3,2.1c-2.6,1-5,0.5-7.1-1.4c-1.5-1.3-2.6-2.9-3.5-4.6 c-1.4-2.5-2.5-5.2-3.5-7.9c-2.5-6.7-4.4-13.4-6.2-20.3c-0.4-1.5-0.8-3.3-1.2-4.5c-9.9,0-19.8,0-29.7,0c-0.1,0-0.2,0.5-0.3,0.7 c-1.9,5.9-3.7,11.8-5.5,17.7c-0.4,1.2-1.3,1.9-2.4,1.9c-1,0-2-0.7-2.3-1.7c-0.1-0.3-0.1-0.7-0.1-1.1c0.9-5,1.9-10.2,2.8-15.2 c0.2-0.9,0.4-1.7,0.6-2.9c-0.4,0-0.7,0-1,0c-3.8,0-7.5,0.2-11.3,0.2c-1.6,0-3.6-1-4-3.2c-0.4-2.2,1.2-4.3,3.4-4.5 c0.5,0,0.9,0,1.4,0c3.8,0.1,7.7,0.1,11.5,0.2c0.5,0,1.1,0,1.7,0c0.3-1.1,0.6-2.3,0.9-3.4c1.6-6,3.3-11.9,5.6-17.7 c1.5-3.8,3.2-7.5,5.5-10.9c1.2-1.8,2.5-3.4,4.2-4.7c1.4-1.1,2.9-1.9,4.7-2c1.4-0.1,2.7,0.3,3.9,1.1c1.2,0.8,2.1,1.8,3,2.9 c1.9,2.5,3.3,5.2,4.6,8c2.6,5.7,4.5,11.6,6.2,17.5c0.9,3.1,1.8,6.2,2.6,9.3c0,0.2,0.1,0.3,0.1,0.5c0.2,0,0.3,0.1,0.4,0.1 c2.3,0.1,4.5,0.1,6.8,0.2c5.3,0.2,10.6,0.3,16,0.5c3.6,0.2,7.2,0.4,10.8,0.6c1.6,0.1,2.6,0.9,2.9,2.3 C123.1,72.7,122,74.4,120.3,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.3,47.4c-0.8-2.3-1.7-4.5-2.9-6.6c-0.2-0.4-0.5-0.7-0.7-1c-0.5-0.6-1.2-0.7-1.9-0.4 c-0.3,0.1-0.7,0.4-0.9,0.6c-0.7,0.9-1.5,1.8-2.1,2.7c-1.3,2.1-2.3,4.3-3.2,6.6C57.3,55.1,55.5,61,54,67c0,0.2-0.1,0.4-0.1,0.6 c7.9,0.1,15.7,0.2,23.6,0.3c-0.2-0.7-0.3-1.2-0.5-1.8C75.3,59.8,73.5,53.5,71.3,47.4z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Aceleradora_Aranda_Emprende"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Armstrong_Downes_Commercial"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplitude);
export default __webpack_public_path__ + "static/media/amplitude.5a6882bd9a32623296616bb9f2935267.svg";
export { ForwardRef as ReactComponent };